import React from "react";

function TibcoTutorial() {
  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "900px",
        margin: "auto",
        lineHeight: "1.7",
        textAlign: "justify",
      }}
    >
      <h1 style={{ textAlign: "center" }}>Welcome to Tibco Tutorial Page!</h1>
      <p>
        Tibco is a middleware product developed by the company Tibco (
        <a
          href="https://www.tibco.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.tibco.com
        </a>
        ). The Tibco product suite comprises several software products used for
        integration of applications, deployment of those applications, and
        monitoring of deployed applications. Tibco Business Works (BW) is used
        for integrating applications, Tibco Administrator is used for deployment
        of applications, and Tibco Hawk is used for monitoring deployed
        applications. Similar to how IBM provides MQ Series as a messaging tool,
        Tibco offers Tibco Rendezvous (RV) and Tibco Enterprise Messaging
        Service (EMS, JMS-based). However, RV and MQ work differently: MQ uses a
        centralized architecture, whereas RV uses a distributed architecture.
      </p>

      <h2>Tibco Business Works</h2>
      <p>
        Tibco products of the suite provide a wide range of integration
        products, of which Tibco BW is easily scalable and widely used. It is
        considered one of the best integration tools in the market as of now.
        It's a GUI tool with little or no programming required.
      </p>
      <p>
        The GUI helps you create a process flow with the help of its wide range
        of available "palettes". Palettes are small built-in architectures which
        you can drag and drop into your workspace to create a process flow.
      </p>

      <h2>Tibco PPTs and Documentation</h2>
      <ul style={{ listStyleType: "none", padding: 0 }}>
        <li style={{ marginBottom: "10px" }}>
          📘{" "}
          <a
            href="/TibcoBW.ppt"
            download
            style={{
              color: "orange",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Tibco BW
          </a>
        </li>
        <li style={{ marginBottom: "10px" }}>
          📘{" "}
          <a
            href="/TIBCO Designer.ppt"
            download
            style={{
              color: "orange",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            TIBCO Designer
          </a>
        </li>
        <li style={{ marginBottom: "10px" }}>
          📘{" "}
          <a
            href="/TIBCO Rendezvous.ppt"
            download
            style={{
              color: "orange",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            TIBCO Rendezvous
          </a>
        </li>
        <li style={{ marginBottom: "10px" }}>
          📘{" "}
          <a
            href="/TibcoHawk.ppt"
            download
            style={{
              color: "orange",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Tibco Hawk
          </a>
        </li>
      </ul>
    </div>
  );
}

export default TibcoTutorial;
